import PropTypes from "prop-types";
import { Button } from "reactstrap";
import useUser from "../../../../../core/hooks/use-user";
import useModal from "../../../../../core/hooks/use-modal";
import FormGenerarCuadroTurno from "../form-generar-cuadro-turnos-automaticos";

const BotonGenerarCuadroTurnos = ({ sedeAreaLider, onGenerarCuadroTurnos }) => {
    const { userCan } = useUser();
    const modalGenerarCuadroTurnos = useModal();

    const mostrarModal = async () => {
        modalGenerarCuadroTurnos.open();
    };

    const cuadroDeTurnosGenerado = () => {
        modalGenerarCuadroTurnos.close();
        onGenerarCuadroTurnos && onGenerarCuadroTurnos();
    };

    if (userCan("nominaGenerarCuadroTurnoAutomatico")) {
        return (
            <>
                <Button
                    color="primary"
                    className="ml-2"
                    title="Generar cuadro de turno mensual automatico"
                    onClick={mostrarModal}
                >
                    <i className="fas fa-calendar-plus"></i>
                    <span className="ml-2">
                        Generar cuadro de turnos
                    </span>
                </Button>
                <FormGenerarCuadroTurno
                    sedeAreaLider={sedeAreaLider}
                    modal={modalGenerarCuadroTurnos}
                    onGenerarCuadroTurnos={cuadroDeTurnosGenerado}
                />
            </>
        );
    }

    return <></>;
};

BotonGenerarCuadroTurnos.propTypes = {
    sedeAreaLider: PropTypes.string,
    onGenerarCuadroTurnos: PropTypes.func,
};

export default BotonGenerarCuadroTurnos;
